const PENDING_SUBSCRIPTION_STORAGE_KEY = 'pendingSubscription';
const PENDING_STORAGE_TTL_MS = 60 * 60 * 1000;

export const ORGANIZATION_PENDING_PLAN_MESSAGE =
  'To subscribe to a new plan, you first need to create a new organization.';

type PendingStoragePayload = {
  expiresAt: number;
};

export function isSubscriptionEntry(search: string): boolean {
  return new URLSearchParams(search).get('subscribe') === 'true';
}

export function captureSubscriptionEntry(search: string): boolean {
  const isSubscription = isSubscriptionEntry(search);

  if (isSubscription) {
    localStorage.setItem(
      PENDING_SUBSCRIPTION_STORAGE_KEY,
      JSON.stringify({ expiresAt: Date.now() + PENDING_STORAGE_TTL_MS })
    );
  }

  return isSubscription;
}

export function hasPendingSubscription(): boolean {
  const rawValue = localStorage.getItem(PENDING_SUBSCRIPTION_STORAGE_KEY);

  if (!rawValue) return false;

  try {
    const parsedValue = JSON.parse(rawValue) as PendingStoragePayload | null;
    if (parsedValue && typeof parsedValue.expiresAt === 'number' && parsedValue.expiresAt > Date.now()) return true;
  } catch {
    // Invalid storage is cleared below.
  }

  clearPendingSubscription();
  return false;
}

export function clearPendingSubscription(): void {
  localStorage.removeItem(PENDING_SUBSCRIPTION_STORAGE_KEY);
}
